@if (tickets().length > 0) {
    <div class="relative inline-flex">
        @if (compact()) {
            <button type="button" class="rounded-full px-2 h-6 flex items-center gap-1 shrink-0 cursor-pointer" [ngClass]="style().compactClass" (click)="toggleList($event)" [tooltip]="summaryTooltip()" [position]="TooltipPosition.DYNAMIC">
                <img [src]="style().icon" alt="activeTickets" class="h-4 w-4" [ngClass]="style().iconClass" />
                <span class="text-sm font-semibold" [ngClass]="style().textClass">{{ tickets().length }}</span>
            </button>
        } @else {
            <button type="button" class="badge border-none text-white gap-1 h-7 cursor-pointer shadow" [ngClass]="style().badgeClass" (click)="toggleList($event)" [tooltip]="summaryTooltip()" [position]="TooltipPosition.BELOW">
                <img [src]="style().icon" alt="activeTickets" class="h-4 w-4 filter-neutrals-white" />
                {{ badgeLabel() }}
            </button>
        }
        @if (listOpened) {
            <ul class="menu fixed z-40 w-80 max-h-80 overflow-y-auto overflow-x-hidden flex-nowrap rounded-box bg-white shadow-lg p-2" [style.top.px]="listPosition.top" [style.left.px]="listPosition.left">
                @for (ticket of tickets(); track ticket.id) {
                    <li class="w-full min-w-0">
                        <a class="flex items-start gap-2 w-full min-w-0" [href]="suggestionUrl(ticket.id, ticket.type)" [target]="openInNewTab() ? '_blank' : '_self'" rel="noopener" (click)="selectTicket($event, ticket)">
                            <img [src]="suggestionTypeIcon(ticket.type)" alt="type" class="h-5 w-5 shrink-0 mt-0.5" />
                            <div class="flex flex-col min-w-0 flex-1">
                                <span class="font-semibold truncate">{{ ticketTitle(ticket) }}</span>
                                @if (ticket.publicMessage || ticket.description) {
                                    <span class="text-xs text-neutrals-grey-04 truncate">{{ ticket.publicMessage || ticket.description }}</span>
                                }
                                <span class="text-xs text-neutrals-grey-04 truncate">{{ ticketDetails(ticket) }}</span>
                            </div>
                            <img [src]="suggestionVisibilityIcon(ticket.visibility)" [alt]="ticket.visibility" class="h-4 w-4 shrink-0 filter-primary-purple-light" [tooltip]="literalService.get('suggestions.visibilities.' + ticket.visibility, true)" [position]="TooltipPosition.LEFT" />
                        </a>
                    </li>
                }
            </ul>
        }
    </div>
}
